import { useOutletContext } from 'react-router-dom'
import type { Agent } from '@/types'
import { Card } from '@/components/ui/Card'
import { EmptyState } from '@/components/ui/EmptyState'

export function AgentGatewaysTab() {
  const { agent } = useOutletContext<{ agent: Agent }>()

  return (
    <div>
      <Card>
        <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginBottom: 4 }}>Runtime</div>
        <div className="mono" style={{ fontSize: 14, marginBottom: 16 }}>{agent.channel === 'voice' ? 'elevenlabs' : 'azure-functions'}</div>
        <EmptyState
          title="Sin gateways adicionales configurados"
          hint="Pendiente de conectar GET /agents/{id}/gateways al backend."
        />
      </Card>
    </div>
  )
}
